import React from 'react';
import MarkdownPage from './MarkdownPage';

export default function PrivacyPolicy() {
  return <MarkdownPage file="privacy-policy.md" />;
}
